import React from "react";

import TodoListItem from "./TodoListItem";
import { useQueryClient } from "@tanstack/react-query";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useOrderingTodos } from "./queries/useQuery";

const TodoList = props => {
  const { data, option } = props;

  const mutation = useOrderingTodos();
  const queryClient = useQueryClient();

  const filteredList = data?.data?.filter(todo => {
    if (option === "select_all") {
      return todo;
    }

    if (option === "todo") {
      return todo.completed === false;
    }

    if (option === "completed") {
      return todo.completed === true;
    }
  });

  const onDragEnd = params => {
    const items = Array.from(data?.data);
    const [reorderedItem] = items.splice(params.source.index, 1);
    items.splice(params.destination.index, 0, reorderedItem);
    queryClient.setQueryData(["todos"], { data: items });
    mutation.mutate({ todos: items });
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-1">
        {(provided, snapshot) => (
          <ul ref={provided.innerRef} {...provided.droppableProps} className={`todo__list ${snapshot.isDraggingOver ? "todo__list--dragging" : ""}`.trim()}>
            {filteredList.length <= 0 && <div className="text-color text-center mt-20">Nenhuma tarefa 🍃</div>}

            {filteredList.map((todo, index) => {

              return (
                <Draggable key={todo.id} draggableId={"draggable-" + todo.id} index={index}>
                  {(provided, snapshot) => (
                    <div className={`${snapshot.isDragging ? "todo__item--dragging" : ""}`.trim()} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                      <TodoListItem todo={todo} />
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </ul>
        )}
      </Droppable>
    </DragDropContext>
  );
}

export default TodoList;